import {Root} from "./store-root";
import {action} from "mobx";
import {Payment} from "../models/payment";
import { API } from "aws-amplify";

export class PaymentStore {
    parent: Root;

    constructor(root: Root) {
        this.parent = root;
    }

    @action MakePayment = async (payment: Payment) => {
        await API.post('backend', `/orders/balance`, {'body': {...payment}});
        await this.parent.Agents.loadAgents();
    }
}